// keys for localstorage
export enum StorageKey {
    accessToken = "i2i_accessToken",
    accessTokenClient = "i2i_accessToken_client",
    shouldAlwaysAsk = "shouldAlwaysAsk",
    teletherapyCurrentRoute ="teletherapyCurrentRoute",
}